import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from "react-redux";
import { signIn } from '../../redux/user/userAction'
import { setActiveProject } from '../../redux/project/projectAction'
import './SignIn.css'
import { urls } from '../../config/url';
import { useHistory } from 'react-router';
import httpRequest from '../../utils/HttpRequest';
import { IProject } from '../../redux/project/projectReducer';
import { Link } from 'react-router-dom';
import { log } from '@antv/g2plot/lib/utils';
import logo from './images/newlogo.png'
import guokan from './images/guokan.png'


import Register from '../register/Register';

const classNames = require('classnames');

function SignIn(props: {
    signIn: (userName: string, token: string) => void,
    setActiveProject: (project: IProject) => void
}) {
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [signIn, setSignIn] = useState(false);
    const [alertMsgID, setAlertMsgID] = useState("");

    const history = useHistory();

    const [userNameInvalid, setUserNameInvalid] = useState(false);
    const [passwordInvalid, setPasswordInvalid] = useState(false);


    const [registerShow, setRegisterShow] = useState(false)

    function handleSignIn() {
        setSignIn(true);
        httpRequest(urls.signIn, {
            USER_NAME: userName,
            USER_PASSWD: password
        }).then(res => {
            if (res.data.errno !== 0) {
                setAlertMsgID("userName_err");
                setPasswordInvalid(true);
                setUserNameInvalid(true);
                setSignIn(false);
                return;
            }
            props.signIn(userName, res.data.data.token);
            localStorage.setItem("userName", userName);
            localStorage.setItem("token", res.data.data.token);
            setSignIn(false);
            const projectName = localStorage.getItem(`${userName}_active_project`);
            const activeProvince = localStorage.getItem(`${userName}_active_Province`);
            const activeCity = localStorage.getItem(`${userName}_active_City`);
            const projectDefault: IProject = {
                activeName: projectName ? projectName : "",
                province: activeProvince ? activeProvince : '',
                city: activeCity ? activeCity : '',
            }
            props.setActiveProject(projectDefault);
            history.replace(`/${userName}`);

        }).catch(error => {
            setSignIn(false);
            setAlertMsgID("userServer_disConnect");
        })
    }

    // useEffect(() => {

    //     if (window.location.href.indexOf('?') == -1) {

    //         let url = window.location.href 
    //         window.location.href = process.env.REACT_APP_SIGNIN_ENTRYPOINT + '?url=' + url  || `http://www.gsde.shop:5546/signin`
    //     } else {
    //         let url = window.location.href
    //         let userName = url.split('?')[1].split('&')[0].split('=')[1]
    //         let token = url.split('?')[1].split('&')[1].split('=')[1]

    //         props.signIn(userName, token);
    //         localStorage.setItem("userName", userName);
    //         localStorage.setItem("token", token);
    //         history.replace(`/${userName}`);
    //     }


    // }, []); // eslint-disable-line

    return (
        // <div className='sign-in-page'>
        //     <div className="sign-in" onKeyPress={e => {
        //         if (e.key === "Enter") {
        //             handleSignIn();
        //         }
        //     }} >

        //     </div> 
        // </div>


        <div className='sign'>

            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 50,}}>
                <img src={logo} alt="" style={{ width: 70, height: 'auto' }} />
                <img src={guokan} alt="" style={{ width: 150, height: 'auto', marginLeft: 15 }} />
                {/* <span style={{ fontSize: 45, marginLeft: 5, fontWeight: 700 }}>国勘云平台</span> */}
            </div>


            <div className='signpage' >
                <div className="sign-in-container float-right">



                    <div className="form-group" style={{ marginTop: 40 }}>
                        <input type="text" className={classNames("form-control", userNameInvalid ? "is-invalid" : null)} id="userName" disabled={signIn} onChange={e => {
                            setUserNameInvalid(false)
                            setUserName(e.currentTarget.value);
                        }} />
                    </div>
                    <div className="form-group" style={{ marginTop: 5 }}>
                        <input type="password" className={classNames("form-control", passwordInvalid ? "is-invalid" : null)} id="userName" disabled={signIn} onChange={e => {
                            setPasswordInvalid(false);
                            setPassword(e.currentTarget.value);
                        }} />
                    </div>
                    {alertMsgID ? <div style={{ color: 'red', height: 20, marginBottom: 6 }}>用户名或密码错误</div> : <div style={{ height: 26 }}></div>}
                    <button
                        className="btn btn-light btn-block"
                        onClick={handleSignIn}
                        disabled={signIn}
                        style={{ background: '#007bff', color: '#fff', height: 42 }}
                    >
                        <FormattedMessage id="sign_in" defaultMessage="Sign In" description="sign in" />
                    </button>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', color: '#1047cb' }}>
                        <div className='float-right register' style={{ marginTop: 12, fontSize: 16, color: '#1047cb', fontWeight: 700, cursor: 'pointer' }} onClick={() => {
                            setRegisterShow(true)

                        }}>立即注册</div>
                    </div>
                </div>


                {
                    registerShow == true ? <Register show={registerShow} editshow={setRegisterShow} /> : ''
                }

            </div>

        </div>

    )
}

export default connect(
    null,
    { signIn, setActiveProject }
)(SignIn);




